import { Fragment } from 'react';

import type { MappedReferencesContext } from '../../../../contexts/ReferencesContext';
import { formatAmount } from '../../../../utils/format-amount.util';
import type { DevisPrestationsGroupRenderModel } from '../utils/build-devis-prestations-render-model.util';

import { DevisPrestationsUsageDetails } from './DevisPrestationsUsageDetails';

interface Props {
  readonly currenciesIdMap: MappedReferencesContext['currenciesIdMap'];
  readonly groups: readonly DevisPrestationsGroupRenderModel[];
  readonly unitsIdMap: MappedReferencesContext['unitsIdMap'];
  readonly vatsIdMap: MappedReferencesContext['vatsIdMap'];
}

export const DevisPrestationsServiceUsagesText = ({
  currenciesIdMap,
  groups,
  unitsIdMap,
  vatsIdMap,
}: Readonly<Props>) => (
  <>
    <p>
      <strong>Notre mission comprend :</strong>
    </p>
    {groups.map((group) => (
      <Fragment key={group.id}>
        {group.sectionTitle ? (
          <p>
            <strong>
              <u>{group.sectionTitle}</u>
            </strong>
          </p>
        ) : null}
        {group.label ? (
          <p>
            <strong>{group.label}</strong>
          </p>
        ) : null}
        <ul>
          {group.usages.map((usage) => (
            <li key={usage.id}>
              <DevisPrestationsUsageDetails
                currenciesIdMap={currenciesIdMap}
                unitsIdMap={unitsIdMap}
                usage={usage}
                vatsIdMap={vatsIdMap}
              />
            </li>
          ))}
        </ul>
        {group.subtotal ? (
          <p>
            Sous-total du groupe (HT) :{' '}
            {formatAmount(group.subtotal, currenciesIdMap)}
          </p>
        ) : null}
      </Fragment>
    ))}
  </>
);
